"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dataScrubberForInt;

function dataScrubberForInt(value) {
  return !value ? value : value.replace(/[^\d-]/g, '');
}